<template>
  <div :id="peer.id" class="host-video-container">
    <!-- <b-button @click="goFullscreen">Fullscreen</b-button> -->
    <video :id="peer.id + '-video'" ref="videoElem" autoPlay="true" playsInline="true" muted="false" />
    <span
      v-if="peer.role === 'host' || peer.role === 'hybrid'"
      class="peer-name"
      :style="'font-size: ' + peerNameSize + ';'"
    >
      {{ peer.displayName }}
      <b-icon
        v-if="peer.micPaused && peer.role === 'host'"
        icon="microphone-off"
        class="mic-icon has-text-danger"
        size="is-small"
      />
      <b-icon
        v-if="connectionType === 'slow-2g'"
        icon="signal-cellular-outline"
        class="signal-icon has-text-danger"
        size="is-small"
      />
      <b-icon v-if="connectionType === '2g'" icon="signal-cellular-1" class="signal-icon is-orange" size="is-small" />
      <b-icon v-if="connectionType === '3g'" icon="signal-cellular-2" class="signal-icon is-yellow" size="is-small" />
      <b-icon v-if="connectionType === '4g'" icon="signal-cellular-3" class="signal-icon is-success" size="is-small" />
    </span>
  </div>
</template>
<script>
/**
 * Video tile for participants in the conference with mic/video/network status
 * @displayName Host Video
 */
import { mapState } from "vuex";
import { db } from "@/firebase";

export default {
  name: "HostVideo",
  components: {},
  props: {
    /**
     * Participant to display
     */
    peer: Object,
    /**
     * Current participant count for responsiveness of the displayed user name
     */
    currentUserCount: Number,
  },
  data() {
    return {
      elementToFullscreen: null,
    };
  },
  computed: {
    ...mapState({
      role: (state) => state.mediasoup.role,
      peers: (state) => state.mediasoup.peers,
    }),
    peerNameSize() {
      if (this.currentUserCount > 9) {
        return "0.75rem";
      } else {
        return "1rem";
      }
    },
    connectionType() {
      // filtering out the peer whose connectionType is required
      let hostpeer = this.peers.filter(
        (peer) => (peer.role === "host" || peer.role === "hybrid") && peer.id === this.peer.id,
      );
      return hostpeer[0].connectionType;
    },
  },
  /**
   * Initialize the videostream which is used by the <video> as srcObject.
   * The stream consume the Track from the video Consumer
   * Executing the fullscreen display if the user is a proxy
   */
  created() {
    const videostream = new MediaStream();
    let videoConsumer = this.peer.videoConsumer;
    videostream.addTrack(videoConsumer._track);
    console.log("videostream", videostream.getTracks());
    this.$nextTick(function () {
      this.$refs.videoElem.srcObject = videostream;
      this.$refs.videoElem.play().catch((error) => console.log("videoElem.play() failed:%o", error));

      this.$nextTick(async function () {
        if (this.role === "proxy") {
          let eventData = null;
          // Getting eventData from firebase
          try {
            const event = await db.doc(
              `organizations/${this.$route.params.organizationId}/events/${this.$route.params.eventId}`,
            );
            eventData = (await event.get()).data();
          } catch (err) {
            console.error("Firebase error, flie: HostVideo.vue, line:125 ", err);
          }
          // Proxy will fullscreen the injectstream
          if (eventData.eventType === "livestream") {
            // this.elementToFullscreen = document.getElementById(
            //   "injectStream-video"
            // );
            this.elementToFullscreen = document.getElementById("hybridUser-video");
          }
          // Proxy will fullscreen the hybrid user video
          if (eventData.eventType === "hybrid") {
            this.elementToFullscreen = document.getElementById("hybridUser-video");
          }
          // Proxy will fullscreen the whole conference for video event
          if (eventData.eventType === "video") {
            this.elementToFullscreen = document.getElementById("conference");
          }

          if (this.elementToFullscreen.requestFullscreen) {
            try {
              await this.elementToFullscreen.requestFullscreen();
            } catch (err) {
              console.error("Fullscreen error, flie: HostVideo.vue, line:142 ", err);
            }
          } else if (this.elementToFullscreen.mozRequestFullScreen) {
            try {
              await this.elementToFullscreen.mozRequestFullScreen();
            } catch (err) {
              console.error("Fullscreen error, flie: HostVideo.vue, line:152 ", err);
            }
          } else if (this.elementToFullscreen.webkitRequestFullscreen) {
            try {
              await this.elementToFullscreen.webkitRequestFullscreen();
            } catch (err) {
              console.error("Fullscreen error, flie: HostVideo.vue, line:161 ", err);
            }
          } else if (this.elementToFullscreen.msRequestFullscreen) {
            try {
              await this.elementToFullscreen.msRequestFullscreen();
            } catch (err) {
              console.error("Fullscreen error, flie: HostVideo.vue, line:170 ", err);
            }
          }
        }
      });
    });
  },
  deactivated() {
    console.log("Videoelem deactivated");
  },
  /**
   * Destroy the Video Elems to prevent `too many WebMediaPlayers already in existence` error
   */
  beforeDestroy() {
    console.log("Videoelem destroy");
    this.$refs.videoElem.srcObject = null;
    this.$refs.videoElem.remove();
  },
  methods: {
    /**
     * Makes the selected element fullscreen.
     * only for testing purposes.
     */
    goFullscreen() {
      if (this.elementToFullscreen.requestFullscreen) {
        this.elementToFullscreen.requestFullscreen();
      } else if (this.elementToFullscreen.mozRequestFullScreen) {
        this.elementToFullscreen.mozRequestFullScreen();
      } else if (this.elementToFullscreen.webkitRequestFullscreen) {
        this.elementToFullscreen.webkitRequestFullscreen();
      } else if (this.elementToFullscreen.msRequestFullscreen) {
        this.elementToFullscreen.msRequestFullscreen();
      }
    },
  },
  beforeUnmount() {
    console.log("Videoelem beforeunmount");
  },
  unmounted() {
    console.log("Videoelem unmounted");
  },
};
</script>

<style lang="scss">
.peer-name {
  background-color: rgba(#000000, 0.8);
  color: white;
  line-height: 1;
  padding: 0.375rem 0.5rem;
  border-radius: 0.375rem;
  position: absolute;
  bottom: 0.2rem;
  left: 0.2rem;
}
.host-video-container {
  position: relative;
  height: 100%;
  max-width: auto;
}
video {
  min-height: 100%;
  margin-left: auto;
  margin-right: auto;
  display: block;
}
</style>
